<template>
<div class="position-relative overflow-hidden" :dir="isEnglish ? 'ltr' : 'rtl'">
    <NavBar/>
    <div>
      <img
        alt=""
        class="background-image"
        src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba">
    </div>
    <ImageBanner :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fride-info-banner.jpg?alt=media&token=b765e21f-2604-4874-a029-3453357e4897'"
                 :paragraph="t('rideExtraInfoBannerParagraph')"
                 size="240px" :title="t('rideInfoPageTitle')"/>
  <b-container>
    <b-row class="justify-content-center">
      <b-col col md="6">
        <b-form>
          <b-form-group
              v-if="!this.extraInformationForRideIsDayInformation"
              id="label-title"
              :class="isEnglish ? 'text-left' : 'text-right'"
              :label="t('rideExtraInfoSectionTitleLabel')"
              label-for="title">
            <b-form-input
                v-model="localExtraInformationForRideEditedTitle"
                id="title"
                :class="['form-control border-primary rounded-2 py-4', isEnglish ? 'text-left' : 'text-right']"
                :placeholder="t('rideExtraInfoSectionTitlePlaceholder')"
                required
                type="text"
                :style="{ direction: isEnglish ? 'ltr' : 'rtl' }"
            ></b-form-input>
          </b-form-group>
          <InsertLinkToTextbox
            :value="localExtraInformationForRideEditedContent"
            :setValue="val => localExtraInformationForRideEditedContent = val"
            textareaRef="ride_extra_information_editor"
          />

          <b-form-group
              id="label-details"
              :class="isEnglish ? 'text-left' : 'text-right'"
              :label="t('rideExtraInfoContentLabel')"
              label-for="albumLink">
            <b-form-textarea
                v-model="localExtraInformationForRideEditedContent"
                ref="ride_extra_information_editor"
                id="textarea"
                class="border-primary rounded-2 p-3"
                max-rows="6"
                :placeholder="t('rideExtraInfoContentPlaceholder')"
                rows="4"
                :style="{ direction: isEnglish ? 'ltr' : 'rtl' }"
            ></b-form-textarea>
          </b-form-group>
        </b-form>

        <div>
          <PrimaryButton 
            v-if="this.extraInformationForRideEditedId"
            class="w-100 mb-5"
            @click="this.updateExtraInformationForRide"
          >
            {{ t('update') }}
          </PrimaryButton>
          <PrimaryButton 
            v-else
            class="w-100 mb-5"
            @click="this.addExtraInformationForRide"
          >
            {{ t('save') }}
          </PrimaryButton>

          <PrimaryButton 
            v-if="this.extraInformationForRideEditedId"
            class="w-100 mb-5 btn-red"
            @click="this.deleteExtraInformationForRide"
          >
            {{ t('rideExtraInfoDeleteSection') }}
          </PrimaryButton>


          <SecondaryButton
            :callBack="ReturnToSingleRide"
            class="w-100 mb-5"
          >
            {{ t('attractionEditingBackToTrip') }}
          </SecondaryButton>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <AppFooter/>
</div>
</template>

<script>
import ImageBanner from "@/components/ImageBanner/ImageBanner.vue";
import PrimaryButton from "@/components/Buttons/PrimaryButton.vue";
import NavBar from "@/components/NavBar.vue";
import AppFooter from "@/components/Template/AppFooter.vue";
import SecondaryButton from "@/components/Buttons/SecondaryButton.vue";
import InsertLinkToTextbox from '@/components/InsertLinkToTextbox.vue';
import { translationMixin } from "@/mixins/translationMixin";

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ExtraInformationForRide',
  mixins: [translationMixin],
  components: {
    AppFooter,
    PrimaryButton,
    ImageBanner,
    NavBar,
    SecondaryButton,
    InsertLinkToTextbox,
    },
  computed: {...mapGetters([  'isAppLoggedIn',
                              'extraInformationForRideEditedTitle',
                              'extraInformationForRideEditedContent',
                              'extraInformationForRideEditedId',
                              'extraInformationForRideIsDayInformation',
                              ]),
      localExtraInformationForRideEditedTitle:{
        get () {
          return this.extraInformationForRideEditedTitle
        },
        set (value) {
          this.$store.commit('setExtraInformationForRideEditedTitle', value )
        }
      },
      localExtraInformationForRideEditedContent:{
        get () {
          return this.extraInformationForRideEditedContent
        },
        set (value) {
          this.$store.commit('setExtraInformationForRideEditedContent', value )
        }
      },
    },
    methods:
    {
    ...mapActions([ 'ReturnToSingleRide',
                    'showModal',
                    'extraInformationForRideLoadDefault',
                    'addExtraInformationForRide',
                    'updateExtraInformationForRide',
                    'deleteExtraInformationForRide',
                    ] ),
  },
  created() {
    const rideIdFromUrl = this.$route.params.ride_id;
    this.$store.commit('setExtraInformationForRideRideId', rideIdFromUrl )
    if (!this.isAppLoggedIn) {
      this.showModal("pleaseLogInInOrderToEditRide");
    }
  },
  destroyed(){
    this.extraInformationForRideLoadDefault()

  },
};
</script>


<style scoped>
  .form-control{
    background-color: white !important;
  }
  .btn-red {
    background: red; /* Adjust the shade of green as needed */
    color: white; /* Change text color if needed */
  }

  /* Make placeholder text lighter/faded for title input when focused */
  #title:focus::placeholder {
    opacity: 0.4 !important;
  }

  /* Make placeholder text lighter/faded for textarea when focused */
  #textarea:focus::placeholder {
    opacity: 0.4 !important;
  }
</style>